import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Target, ShieldCheck, CreditCard } from 'lucide-react';
export function Hero() {
  const badges = [{
    icon: <FileText size={16} data-id="element-74" />,
    text: 'PDF descargable'
  }, {
    icon: <Zap size={16} data-id="element-75" />,
    text: 'Acceso inmediato'
  }];
  return <section className="relative pt-4 pb-10 px-4 md:pt-6 md:pb-16 max-w-5xl mx-auto text-center overflow-hidden" data-id="element-76">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(152,224,186,0.25) 0%, rgba(152,224,186,0.08) 40%, transparent 70%)'
    }} data-id="element-77" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-78">
        <span className="inline-block py-1 px-3 rounded-full bg-mint/10 text-mint font-semibold text-sm mb-3 tracking-wide uppercase" data-id="element-79">
          🥑Salud en tu Plato™
        </span>

        <h1 className="md:text-6xl lg:text-7xl mb-4 font-[900] font-['Open_Sans',_sans-serif] text-white text-[32px]" data-id="element-80">
          Tu año de consultas <span className="text-mint" data-id="element-81">resuelto</span>
        </h1>

        <div className="mb-4 flex justify-center" data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/1mpzo9WFpRSLbX9cWbiVUE/ChatGPT_Image_11_abr_2026,_02_43_05_p.m..png" alt="Megapack Nutricionistas Kit Profesional" className="w-full max-w-[280px] md:max-w-xs drop-shadow-2xl pl-[40px] pr-[40px]" data-id="element-83" />
        </div>

        <p className="md:text-3xl italic text-mint/80 mb-4 max-w-4xl mx-auto text-[18px] font-[800] font-[Avenir,_sans-serif]" data-id="element-84">
          "Listo para usar. Sin buscar más. Sin improvisar. Sin perder
          domingos."
        </p>

        <p className="text-white/60 max-w-2xl mx-auto mb-5 text-[16px]" data-id="element-85">
          El sistema para nutricionistas en Argentina: consulta + planificación
          + protocolos + seguimiento + criterio clínico, listo para aplicar
          desde hoy. Sin armar desde cero. Sin dudar en consulta.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-6 max-w-4xl mx-auto" data-id="element-86">
          {badges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5 bg-surface border border-mint/10 px-3 py-1.5 rounded-md text-sm text-white/80 font-medium shadow-sm" data-id="element-87">
              <span className="text-mint" data-id="element-88">{badge.icon}</span>
              {badge.text}
            </div>)}
        </div>

        <motion.a href="#comprar" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-block bg-mint hover:bg-mint/80 text-black font-bold text-lg md:text-xl py-4 px-8 md:px-12 rounded-xl shadow-lg shadow-mint/20 transition-colors" data-id="element-89">
          👩‍⚕️QUIERO MI MEGAPACK NUTRI PRO LISTO AHORA
        </motion.a>

        <div className="flex flex-wrap justify-center gap-4 mt-4" data-id="element-90">
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-91">
            <Target size={16} className="text-mint" data-id="element-92" />
            Enfoque real
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-93">
            <ShieldCheck size={16} className="text-mint" data-id="element-94" />
            Pago seguro
          </div>
          <div className="flex items-center gap-1.5 text-white/50 text-sm font-medium" data-id="element-95">
            <CreditCard size={16} className="text-mint" data-id="element-96" />
            Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}